import '../scss/app.scss';
import ScrollReveal from 'scrollreveal';
import Rellax from 'rellax';


// esm-bundlers includes the compiler, the compiler is needed for in-DOM templates or templates via inline JavaScript strings
// See: https://v3.vuejs.org/guide/installation.html#explanation-of-different-builds
import { createApp } from 'vue/dist/vue.esm-bundler';
import NebulaCover from '@/js/components/NebulaCover.vue';
import SwitchableText from "@/js/components/SwitchableText";
import AlertMessage from './components/AlertMessage.vue'
import { IS_MOBILE } from "@/js/const";
import CustomRequirements from '@/js/components/CustomRequirements.vue';
import Requirement from "@/js/components/Requirement";
import Totals from "@/js/components/Totals";
import Contact from "@/js/components/Contact";
import '@/js/utils/scroll-header.js';

const Root = {
  delimiters: ['[[', ']]'],

  data() {
    return {
      hyperspace: false,
      home: {
        overCTA: false,
      },
      calculator: {
        application: '',
        requirements: [],
        customRequirements: [],
        contact: [],
        description: '',
      }
    }
  },

  mounted() {
    new Rellax('.rellax');
    ScrollReveal().reveal('.reveal', { delay: 500, interval: 100, duration: 1000, distance: '25px' });
    ScrollReveal().reveal('.reveal-right', { delay: 200, interval: 200, duration: 1500, distance: '25px', origin: 'right' });

    this.initToasts()
    this.initCTAProximity()
  },
  methods: {
    toggleRequirement(req, active) {
      if (active) {
        let existing = this.calculator.requirements.find(item => item.id === req.id);
        if (!existing) {
          this.calculator.requirements.push(req);
        }
      } else {
        let index = this.calculator.requirements.findIndex(item => item.id === req.id);
        this.calculator.requirements.splice(index, 1);
      }
    },

    setCustomRequirements(customRequirements) {
      this.calculator.customRequirements = customRequirements;
    },

    setContactData(contact) {
      this.calculator.contact = contact;
    },

    setDescriptionQuotation(description) {
      this.calculator.description = description;
    },

    homeOnOverCTA() {
      if (!IS_MOBILE) {
        this.home.hyperspace = true;
      }
    },

    homeOnLeaveCTA() {
      if (!IS_MOBILE) {
        this.home.hyperspace = false;
      }
    },

    initCTAProximity() {
      // Triggers the hyperspace effect when the cursor gets close to the CTA button,
      // instead of waiting for an actual hover over it
      const cta = document.querySelector('.btn-cta-custom');
      if (IS_MOBILE || !cta) return;

      const proximity = 140; // Distance in px from the button edges that activates the effect
      let ticking = false;

      document.addEventListener('mousemove', (event) => {
        if (ticking) return;
        ticking = true;

        requestAnimationFrame(() => {
          ticking = false;
          // The rect is read on every frame because the button moves with the rellax parallax
          const rect = cta.getBoundingClientRect();
          const dx = Math.max(rect.left - event.clientX, 0, event.clientX - rect.right);
          const dy = Math.max(rect.top - event.clientY, 0, event.clientY - rect.bottom);
          this.home.hyperspace = Math.hypot(dx, dy) <= proximity;
        });
      });
    },
    initToasts() {
      const liveToastElement = document.getElementById('liveToast');

      if (liveToastElement) {
        liveToastElement.className = liveToastElement.className + " show";
        setTimeout(function () { liveToastElement.className = liveToastElement.className.replace("show", ""); }, 4000);
      }
    }
  }
};

const app = createApp(Root);


// Components registration
app.component('nebula-cover', NebulaCover);
app.component('switchable-text', SwitchableText);
app.component('alert-message', AlertMessage);
app.component('custom-requirements-calculator', CustomRequirements);
app.component('requirement', Requirement);
app.component('totals', Totals);
app.component('contact', Contact);
app.mount('#app');
